<template>
  <div class="send-record">
    <div class="main-title">
      <p @click="back">电池管理</p>
      <p>>查看行驶轨迹</p>
    </div>
    <div class="main-body">
      <div class="list">
        <span>行驶时间</span>
        <el-date-picker
          v-model="startTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          placeholder="开始日期"
        ></el-date-picker>
        -
        <el-date-picker
          v-model="endTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          placeholder="结束日期"
        ></el-date-picker>
        <span class="ml10">设备编号</span>
        <el-input class="list-input" size="mini" v-model="param" placeholder="请输入设备编号/通讯板编号"></el-input>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
      </div>
      <div class="amap-page-container">
        <el-amap vid="batteryTrack" :zoom="zoom" :center="center">
          <el-amap-polyline
            :editable="polyline.editable"
            :path="polyline.path"
            :strokeColor="polyline.strokeColor"
          ></el-amap-polyline>
          <el-amap-marker
            v-for="(marker, index) in markers"
            :position="marker.position"
            :visible="marker.visible"
            :draggable="marker.draggable"
            :vid="index"
            :label="marker.label"
            :events="marker.events"
            :icon="marker.icon"
            :offset="marker.offset"
            v-bind:key="index"
          ></el-amap-marker>
        </el-amap>
      </div>
      <div
        class="marker-detail"
        v-if="trackPoint.seqNo || trackPoint.coordinate || trackPoint.miles"
      >
        <div class="seq-info">{{ trackPoint.seqNo ? trackPoint.seqNo : '--' }}</div>
        <div class="mile-info">
          {{ trackPoint.miles ? trackPoint.miles : '--' }}
          <span style="font-size: 14px;">公里</span>
        </div>
        <div class="row">
          <span>经度：</span>
          {{ trackPoint.coordinate ? trackPoint.coordinate[0] : '--' }}
          <span class="ml30">纬度：</span>
          {{ trackPoint.coordinate ? trackPoint.coordinate[1] : '--' }}
        </div>
        <div class="row">
          地址：
          <span>{{ address ? address : '--' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: "batteryTrack",
  data() {
    return {
      param: "",
      startTime: "",
      endTime: "",
      trackPointList: [],
      address: "",
      zoom: 15,
      center: [120.15, 30.28],
      markers: [],
      trackPoint: {},
      polyline: {
        path: [],
        editable: false
      },
      seletedIndex: null
    };
  },
  mounted() {
    this.startTime = Utils.getCurrentDate() + " 00:00";
    this.endTime = Utils.getCurrentDate() + " 23:59";
    let prePageQueryParams = "";
    if (this.$route.query.searchCondition) {
      prePageQueryParams +=
        "&searchCondition=" + this.$route.query.searchCondition;
    }
    if (this.$route.query.belongTarget) {
      prePageQueryParams += "&belongTarget=" + this.$route.query.belongTarget;
    }
    if (this.$route.query.targetNumber) {
      prePageQueryParams += "&targetNumber=" + this.$route.query.targetNumber;
    }
    if (this.$route.query.belongTargetSeq) {
      prePageQueryParams +=
        "&belongTargetSeq=" + this.$route.query.belongTargetSeq;
    }
    if (this.$route.query.version) {
      prePageQueryParams += "&version=" + this.$route.query.version;
    }
    if (this.$route.query.status) {
      prePageQueryParams += "&status=" + this.$route.query.status;
    }
    if (this.$route.query.manufacturer) {
      prePageQueryParams += "&manufacturer=" + this.$route.query.manufacturer;
    }
    if (this.$route.query.beginIndex) {
      prePageQueryParams += "&beginIndex=" + this.$route.query.beginIndex;
    }
    if (prePageQueryParams.length > 0) {
      prePageQueryParams = prePageQueryParams.substring(
        1,
        prePageQueryParams.length - 1
      );
    }
  },
  methods: {
    queryBatteryTrack() {
      let self = this;
      self.seletedIndex = null;
      self.trackPoint = {};
      self.polyline.path = [];
      self.markers = [];
      const loading = this.$loading({
        lock: true,
        text: "数据正在加载，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let params = {
        param: this.param,
        startTime: this.startTime,
        endTime: this.endTime
      };
      this.$http
        .post(
          "/managementPlatform/electricity/queryBatteryTrack",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          loading.close();
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          if (res.ldata.length == 1) {
            res.ldata = [...res.ldata, ...res.ldata]
          }
          self.trackPointList = res.ldata;
          let path = [];
          let markers = [];
          self.trackPointList.forEach((element, index) => {
            path.push([element.coordinate[0], element.coordinate[1]]);
            markers.push({
              position: [element.coordinate[0], element.coordinate[1]],
              visible: true,
              draggable: false,
              label: {
                content: element.miles,
                offset: [-20, -40]
              },
              events: {
                click: e => {
                  self.trackPoint = self.trackPointList[index];
                  if (self.seletedIndex != null) {
                    self.markers[self.seletedIndex].icon =
                      "/static/ic-circle-unselected.png";
                    self.markers[self.seletedIndex].offset = [-5, -5];
                  }
                  self.markers[index].icon = "/static/ic-circle-selected.png";
                  self.markers[index].offset = [-7, -7];
                  self.seletedIndex = index;
                  self.getAddress();
                }
              },
              icon: "/static/ic-circle-unselected.png",
              offset: [-5, -5]
            });
          });
          self.polyline.path = path;
          self.polyline.strokeColor = "#FA0000FF";
          if (path.length > 0) {
            self.center = path[Math.ceil(path.length / 2)];
          }
          self.markers = markers;
        })
        .catch(function (response) {
          loading.close();
          console.log(response);
        });
    },

    getAddress() {
      let self = this;
      if (
        !this.trackPoint.coordinate ||
        this.trackPoint.coordinate.length != 2
      ) {
        return;
      }
      let params = {
        longitude: this.trackPoint.coordinate[0],
        latitude: this.trackPoint.coordinate[1],
        type: "0"
      };
      this.$http
        .post("/post/getAddress", this.$qs.stringify(params))
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          let address = res.mdata.address;
          self.address = address.formatted_address;
          if (!address.formatted_address) {
            self.address = address.province + address.city + address.district;
          }
        })
        .catch(function (response) {
          console.log(response);
        });
    },

    onQueryBtnClick() {
      this.queryBatteryTrack();
    },

    back() {
      this.$router.push("/managePage/batteryMgmt?" + this.prePageQueryParams);
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #bee6b3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.amap-page-container {
  width: 100%;
  height: 700px;
}

.marker-icon {
  width: 11px;
  height: 11px;
  background: rgba(250, 0, 0, 1);
}

.marker-detail {
  position: relative;
  top: -180px;
  left: 10px;
  z-index: 999;
  width: 351px;
  height: 150px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.32);
  border-radius: 5px;
  padding-top: 15px;
  padding-left: 18px;
  padding-right: 18px;
}

.marker-detail .seq-info {
  width: 100%;
  height: 18px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(119, 119, 119, 1);
  line-height: 18px;
}

.marker-detail .mile-info {
  width: 100%;
  height: 30px;
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(39, 39, 39, 1);
  line-height: 30px;
  margin-top: 20px;
}

.marker-detail .row {
  width: 100% px;
  height: 18px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(119, 119, 119, 1);
  line-height: 18px;
  margin-top: 10px;
}

.unselected-marker {
  width: 19px;
  height: 19px;
  background: rgba(232, 229, 213, 1);
  border: 2px solid rgba(0, 48, 250, 1);
}
</style>

<style>
.amap-marker-label {
  width: 48px;
  height: 28px;
  background: rgba(255, 223, 0, 1);
  border-radius: 3px 3px 3px 0px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(39, 39, 39, 1);
  line-height: 28px;
  border: none;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batteryTrack.vue